import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { View, StyleSheet } from 'react-native'
import InputFormik from '../InputFormik'
import Button from '../Button'

export const setPayload = ({ tractor_number, trailer_number }, movementNumber) => ({
  capacity: {
    tractor_number,
    trailer_number
  },
  movement_id: movementNumber
})

const UpdateOrderForm = ({ onSubmit, tractor, movementNumber, loadUpdate }) => {
  return (
    <Formik
      initialValues={tractor}
      onSubmit={values => onSubmit(setPayload(values, movementNumber))}
    >
      {({ values, setFieldValue, handleSubmit }) => (
        <View style={styles.form}>
          <View style={styles.row}>
            <View style={styles.input}>
              <InputFormik
                name='tractor_number'
                label='Tractor number'
                value={values?.tractor_number || ''}
                onChange={setFieldValue}
                testID='orderFormTractorNumberInput'
                accessibilityLabel='orderFormTractorNumberInput'
              />
            </View>
            <View style={styles.input}>
              <InputFormik
                label='Trailer number'
                name='trailer_number'
                value={values?.trailer_number || ''}
                onChange={setFieldValue}
                testID='orderFormTrailerNumberInput'
                accessibilityLabel='orderFormTrailerNumberInput'
              />
            </View>
          </View>
          <View style={styles.button}>
            <Button
              title='Save'
              onPress={handleSubmit}
              loading={loadUpdate}
              testID='orderFormButton'
              accessibilityLabel='orderFormButton'
            />
          </View>
        </View>
      )}
    </Formik>
  )
}
const styles = StyleSheet.create({
  form: {
    flex: 1
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  input: {
    width: '48%'
  }
})

UpdateOrderForm.defaultProps = {
  tractor: {},
  movementNumber: ''
}

UpdateOrderForm.propTypes = {
  movementNumber: PropTypes.string.isRequired,
  tractor: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loadUpdate: PropTypes.bool.isRequired
}

export default UpdateOrderForm
